import { analytics, NoPlanBannerEvents } from '@/lib/analytics'

interface NoPlanBannerEventData {
  source: 'dashboard' | 'sidebar' | 'mobile-banner'
  planFeature: string
}

export function trackNoPlanBannerViewed(data: NoPlanBannerEventData): void {
  analytics.track(NoPlanBannerEvents.VIEWED, {
    source: data.source,
    plan_feature: data.planFeature,
  })
}

export function trackNoPlanBannerClicked(data: NoPlanBannerEventData): void {
  analytics.track(NoPlanBannerEvents.CLICKED, {
    source: data.source,
    plan_feature: data.planFeature,
  })
}
